module.exports = __webpack_public_path__ + "img/keyboard_65_fluffy1.e5615981.png";